// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__pVmxr","footerImage":"Footer_footerImage__wjwS3"};